// src/hooks/useProductPageContent.js
import { useState } from "react";
import { updateUserProfile } from "../services/profileService";

const useUpdateProfile = () => {
  const [status, setStatus] = useState("idle"); // idle | loading | done | error
  const [error, setError] = useState("");
  const [data, setData] = useState([]);

  const sentUpdateProfile = async (req) => {
    setStatus("loading");
    setError("");

    try {
      const response = await updateUserProfile(req);

      if (response?.status !== "Error") {
        setData(response.data ?? response); // depending on API shape
        setStatus("done");
      } else {
        setStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };

  const resetStatus = () => {
    setStatus("idle");
    setError("");
  };

  return {
    sentUpdateProfile,
    data,
    status,
    error,
    resetStatus,
  };
};

export default useUpdateProfile;
